import React from 'react'
import { withStyles } from 'material-ui/styles'
import Button from 'material-ui/Button'
import {CircularProgress} from 'material-ui/Progress'
import Typography from 'material-ui/Typography'
import KeyboardBackspaceIcon from 'material-ui-icons/KeyboardBackspace'
import { Link } from 'react-router-dom'
import Table, { TableBody, TableCell, TableHead, TableRow } from 'material-ui/Table'
import AddPriceCard from './AddPriceCard'
import moment from 'moment'

const styles = theme => ({
  root: {
    width: '100%',
    overflowX: 'auto'
  },
  table: {
    minWidth: 200
  }
})

const ProductPrice = (props) => {
  const {
    classes,
    product,
    onPriceAdded,
    requestOngoing
  } = props

  // fair play
  let prices = product.prices || []

  return <div>
    <Link to='/products'>
      <Button className={classes.button} >
        <KeyboardBackspaceIcon className={props.classes.leftIcon} />
          Go Back
      </Button>
    </Link>

    <AddPriceCard onAddPrice={(date, price) => onPriceAdded(date, price)} />
    <br />
    {(requestOngoing &&
    <Typography type='caption' gutterBottom align='center'>
      <CircularProgress className={classes.progress} size={25} />
        Adding Price
    </Typography>
    )}

    <Table className={classes.table}>
      <TableHead>
        <TableRow>
          <TableCell>Date</TableCell>
          <TableCell>Price</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {prices.map((price, index) => {
          return (
            <TableRow key={index}>
              <TableCell>{moment(price.date).format('DD-MMM-YYYY, H:mm:ss')}</TableCell>
              <TableCell>{price.price}</TableCell>
            </TableRow>
          )
        })}

      </TableBody>
    </Table>
  </div>
}

export default withStyles(styles)(ProductPrice)



// WEBPACK FOOTER //
// ./src/products/ProductPrice.js